const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the event prework url component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('courseSelection', ['ContentIntegrations', 'AccessHelper', function (ContentIntegrations, AccessHelper) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../../templates/directives/cms/course-selection.html'),
    link: function (scope, element, attrs) {
      scope.loading = true;
      scope.allowed = {
        tracks: AccessHelper.isAllowed(
          ['admin', 'content', 'all_create'], [
            ['admin', 'content', 'tracks_create'],
          ], ['admin', 'creator', 'collaborator']
        ),
        thirdParty: AccessHelper.isAllowed(
          ['admin', 'content', 'all_create'], [
            ['admin', 'content', 'imported_content_create'],
          ], ['admin', 'creator', 'collaborator']
        )
      };

      ContentIntegrations.existing().$promise
      .then(function(results) {
        if (!results || !results.integrations || !results.integrations.length) {
          return;
        }
        results.integrations.forEach(function(item) {
          scope[item] = true;
        });
        scope.loading = false;
      });
    }
  };
}]);
